import React, { useState, useEffect } from 'react';
import { ModalWrapper } from './ModalWrapper';
import { POPUP_STYLES } from '../../constants/popupStyles';

interface EditCommentsModalProps {
  isOpen: boolean;
  onClose: () => void;
  initialNotes: string;
  onSave: (newNotes: string) => Promise<void>;
  isSaving?: boolean;
  title?: string;
  label?: string;
  placeholder?: string;
}

export const EditCommentsModal: React.FC<EditCommentsModalProps> = ({
  isOpen,
  onClose,
  initialNotes,
  onSave,
  isSaving = false,
  title = 'Edit Comments',
  label = 'Comment',
  placeholder = 'Enter value',
}) => {
  const [notes, setNotes] = useState(initialNotes);
  const [localSaving, setLocalSaving] = useState(false);

  useEffect(() => {
    setNotes(initialNotes);
  }, [initialNotes, isOpen]);

  const isSavingState = isSaving || localSaving;

  const handleSave = async () => {
    setLocalSaving(true);
    try {
      await onSave(notes);
    } finally {
      setLocalSaving(false);
    }
  };

  const handleCancel = () => {
    setNotes(initialNotes);
    onClose();
  };

  return (
    <ModalWrapper
      isOpen={isOpen}
      onClose={handleCancel}
      title={title}
      isLoading={isSavingState}
    >
      <div className="mb-6">
        <label className="block text-gray-700 font-medium mb-2">
          {label}
        </label>
        <input
          type="text"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder={placeholder}
          disabled={isSavingState}
          className={POPUP_STYLES.input}
        />
      </div>

      <div className="flex gap-4 justify-center">
        <button
          onClick={handleSave}
          disabled={isSavingState}
          className={POPUP_STYLES.button}
        >
          {isSavingState ? 'Saving...' : 'Save'}
        </button>
        <button
          onClick={handleCancel}
          disabled={isSavingState}
          className={POPUP_STYLES.button}
        >
          Cancel
        </button>
      </div>
    </ModalWrapper>
  );
};
